import { useState, useEffect, useLayoutEffect } from "react";
import { useNavigate } from "react-router-dom";

// ─── Photo map ─────────────────────────────────────────────────────────────
const memberImages = {
  "Manish Kumar": "/team_photos/image139.jpg",
  "Anshu Kumar": "/team_photos/image140.jpg",
  "Joseph Mattamana": "/team_photos/image141.jpg",
  "Sudesh Kakkar": "/team_photos/image142.jpg",
  "Pawan Kumar": "/team_photos/image143.jpg",
  "Sreenath S. Das": "/team_photos/image144.jpg",
  "Aamir Iqbal": "/team_photos/image2.jpg",
  "Anamika Gahlot": "/team_photos/image7.jpg",

  "Amit Kumar": "/team_photos/image111.png",
  "Abhishek Bisui": "/team_photos/image1.jpg",
  "Adarsh Tripathi": "/team_photos/image61.jpg",
  "Alka Yadav": "/team_photos/image55.jpg",
  "Alok Verma": "/team_photos/image125.jpg",
  "Abhineet Baruah": "/team_photos/image16.jpg",
  "Saksham Gupta": "/team_photos/image28.jpg",

  "Alpesh Parmar": "/team_photos/image85.jpg",
  "-": "/team_photos/image12.jpg",
  "Arnav": "/team_photos/image12.jpg",
  "Veluri Raviteja": "/team_photos/image67.jpg",

  "Ramkaran Singh": "/team_photos/image23.png",
  "Arshad Hussain": "/team_photos/image110.jpg",
  "Ashish Saini": "/team_photos/image30.jpg",
  "Ashutosh Pathak": "/team_photos/image37.jpg",
  "Ayan Kumar Mondal": "/team_photos/image69.jpg",
  "BSS Kumar": "/team_photos/image78.jpg",
  "Bala Saidulu Nallagondla": "/team_photos/image33.jpg",
  "Bhairav Changkakoty": "/team_photos/image72.jpg",
  "Bhargab Goswami": "/team_photos/image91.jpg",
  "Bhavishy Kumar Gupta": "/team_photos/image47.jpg",
  "Brijbhushan Ahuja": "/team_photos/image98.jpg",
  "Brijesh Kr. Pandey": "/team_photos/image27.jpg",
  "CH Deepank": "/team_photos/image118.jpg",
  "Choppala Satya Tej": "/team_photos/image26.jpg",
  "Davinder Singh": "/team_photos/image5.jpg",
  "Deepak Gunwant": "/team_photos/image44.jpg",
  "Deepak Kumar Vishwakarma": "/team_photos/image59.jpg",
  "Devendra Kumar Aggarwal": "/team_photos/image46.jpg",
  "Dipankan S.": "/team_photos/image13.jpg",
  "G. Parthiban": "/team_photos/image73.jpg",
  "Hardeep P.": "/team_photos/image34.jpg",
  "Harini L": "/team_photos/image124.jpg",
  "Haritha Maddi": "/team_photos/image8.jpg",
  "Hemasundara Rao Kambala": "/team_photos/image90.jpg",
  "Hrushikesh Reddy": "/team_photos/image131.jpg",
  "Jagannath Chaudhary": "/team_photos/image134.jpg",
  "Jainendra Srivastava": "/team_photos/image74.jpg",
  "Jayant Kumar": "/team_photos/image64.jpg",
  "Jayashree Prusty": "/team_photos/image117.jpg",
  "Jeetendra Bobanga": "/team_photos/image53.jpg",
  "Jitendra Dadhich": "/team_photos/image45.jpg",
  "K Praveen Kumar": "/team_photos/image116.png",
  "Satya Narayan": "/team_photos/image106.jpg",
  "Kalaiselvi S.": "/team_photos/image20.jpg",
  "Kaushal Agrawal": "/team_photos/image123.jpg",
  "Kitho Stephen": "/team_photos/image94.jpg",
  "Koushik Mondal": "/team_photos/image109.jpg",
  "Krishna Reddy": "/team_photos/image81.jpg",
  "Lakshman Katherla": "/team_photos/image113.jpg",
  "Malini Chakraborty": "/team_photos/image10.jpg",
  "Manav Kumar": "/team_photos/image89.jpg",
  "Mandeep Singh": "/team_photos/image21.jpg",
  "Manoj Mehta": "/team_photos/image36.jpg",
  "Manoj Mishra": "/team_photos/image29.jpg",
  "Mathialagan P": "/team_photos/image119.jpg",
  "Mudavath Priyatham Naik": "/team_photos/image101.jpg",
  "Murugesan M K": "/team_photos/image39.jpg",
  "N Harish": "/team_photos/image401.jpg",
  "Nainesh B Shah": "/team_photos/image25.jpg",
  "Nebula Bagchi": "/team_photos/image4.jpg",
  "Neeraj Kumar": "/team_photos/image631.jpg",
  "Neerudu Ragalbande": "/team_photos/image95.jpg",
  "Neha Pandey": "/team_photos/image83.jpg",
  "Nikhil Singh": "/team_photos/image84.jpg",
  "Pamini BN": "/team_photos/image57.jpg",
  "Pankaj kumar": "/team_photos/image52.jpg",
  "Rajiv Vasisth": "/team_photos/image129.png",
  "Nirmal Kumar Mishra": "/team_photos/image60.jpg",
  "Vishal Kumar": "/team_photos/image80.jpg",
  "Pankaj Kumar": "/team_photos/image100.jpg",
  "Paul Mickey Toppo": "/team_photos/image115.jpg",
  "Pawan Kumar Jalutharia": "/team_photos/image107.jpg",
  "Pawan Singh": "/team_photos/image3.jpg",
  "Peter Vaddi": "/team_photos/image51.jpg",
  "Piyush Nayal": "/team_photos/image54.jpg",
  "Prafful Mittal": "/team_photos/image127.jpg",
  "Prashant Kumar Dubey": "/team_photos/image6.jpg",
  "Prateek Gupta": "/team_photos/image77.jpg",
  "Praveen Kumar Jha": "/team_photos/image50.jpg",
  "Prem Prakash Hansda": "/team_photos/image114.jpg",
  "Prosenjit Das": "/team_photos/image128.jpg",
  "Raghvendra Sharma": "/team_photos/image88.jpg",
  "Rahman A M": "/team_photos/image130.jpg",
  "Rajjan Singh Thakur": "/team_photos/image38.jpg",
  "Rakesh Kumar Yadav": "/team_photos/image19.jpg",
  "Ramu Pedumajji": "/team_photos/image43.jpg",
  "Ravi Kumar Sharma": "/team_photos/image75.jpg",
  "Rehan Ansari": "/team_photos/image9.jpg",
  "Roshan P Koshy": "/team_photos/image17.jpg",
  "Rupjyoti Dutta": "/team_photos/image24.jpg",
  "Sabyasachi Bhowmick": "/team_photos/image135.jpg",
  "Sabyasachi Saikia": "/team_photos/image151.jpg",

  "Sagun Devshali": "/team_photos/image108.jpg",
  "Sanjoy Das": "/team_photos/image961.jpg",
  "Santanu Das": "/team_photos/image112.jpg",
  "Santosh Kumar Gupta": "/team_photos/image41.jpg",
  "Santosh Kumar Sahu": "/team_photos/image48.jpg",
  "Sarabjeet Singh Dhanjal": "/team_photos/image32.jpg",
  "Satish Chandra Gupta": "/team_photos/image126.jpg",
  "Satish Kumar": "/team_photos/image86.jpg",
  "Saswata Bag": "/team_photos/image102.png",
  "Dharmendra Kumar": "/team_photos/image65.png",
  "Sayandeep Roy": "/team_photos/image76.jpg",
  "Sh Bronson Aimol": "/team_photos/image58.jpg",
  "Shailesh Chandra Sinha": "/team_photos/image35.jpg",
  "Shashi Kumar Suman": "/team_photos/image97.jpg",
  "Shrishti Awasthi": "/team_photos/image68.jpg",
  "Shubham Gupta": "/team_photos/image93.jpg",
  "Shubhendu Sharan Gupta": "/team_photos/image132.jpg",
  "Sohil Shah": "/team_photos/image121.jpg",
  "Sonu Kumar Singh": "/team_photos/image71.jpg",
  "Sudhir Sharma": "/team_photos/image22.jpg",
  "Sugata Guchhait": "/team_photos/image42.jpg",
  "Sukumar Laha": "/team_photos/image92.jpg",
  "Suresh Konka": "/team_photos/image15.jpg",
  "Suryamani Kumar": "/team_photos/image133.jpg",
  "Sushant Gupta": "/team_photos/image79.jpg",
  "Umang Nagpal": "/team_photos/image18.jpg",
  "V L L Krishnaveni Emani": "/team_photos/image122.jpg",
  "V. Sreedher": "/team_photos/image11.jpg",
  "Vaibhav Kumar Lakra": "/team_photos/image104.jpg",
  "Venkatesh P": "/team_photos/image14.jpg",
  "Vinay Sahu": "/team_photos/image31.jpg",
  "Vinod Kanobaji Zile": "/team_photos/image56.jpg",
  "Vishal Mittal": "/team_photos/image103.jpg",
  "Vivek Singh": "/team_photos/image120.jpg",
};

function getPhoto(name) {
  const path = memberImages[name];
  return path ? `/images${path}` : null;
}

// ─── Avatar ────────────────────────────────────────────────────────────────
function Avatar({ name, size = 110 }) {
  const [imgError, setImgError] = useState(false);
  const src = getPhoto(name);
  const initials = name.split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase();

  const baseStyle = {
    width: size,
    height: size,
    minWidth: size,
    flexShrink: 0,
  };

  if (src && !imgError) {
    return (
      <img
        src={src}
        alt={name}
        onError={() => setImgError(true)}
        style={{
          ...baseStyle,
          objectFit: "contain",
          backgroundColor: "#08130e",
          display: "block",
        }}
      />
    );
  }

  return (
    <div style={{
      ...baseStyle,
      background: "linear-gradient(135deg, #0d2016 0%, #0a1a10 100%)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: size * 0.33,
      fontWeight: 700,
      color: "#4ade80",
      letterSpacing: "0.04em",
    }}>
      {initials}
    </div>
  );
}

// ─── Data ──────────────────────────────────────────────────────────────────
const useCases = [
  {
    id: "U2UCI362", domain: "Process Plant", location: "Rajahmundry",
    title: "ML-Based Refinery Profit Optimisation & Quality Assurance",
    lead: "Mudavath Priyatham Naik", leadRole: "Team Lead",
    mentor: "Santanu Das", mentorRole: "Team Mentor",
    members: [
      { name: "Santanu Das", role: "Team Mentor" },
      { name: "Mudavath Priyatham Naik", role: "Team Lead" },
      { name: "Amit Kumar", role: "Programming Lead" },
      { name: "Rahman A M", role: "Project Manager" },
      { name: "Shubhendu Sharan Gupta", role: "Team Member" },
      { name: "Hrushikesh Reddy", role: "Technical Lead" },
      { name: "Prafful Mittal", role: "Team Member" },
      { name: "Suryamani Kumar", role: "Team Member" },
      { name: "Koushik Mondal", role: "Quality Control" },
      { name: "CH Deepank", role: "Team Member" },
    ],
  },
  {
    id: "U1UCI080", domain: "Drilling", location: "RCC Chennai",
    title: "Real-Time Pore Pressure Prediction using AI for Drilling Safety",
    lead: "Lakshman Katherla", leadRole: "Team Lead",
    mentor: "Jagannath Chaudhary", mentorRole: "Team Mentor",
    members: [
      { name: "K Praveen Kumar", role: "Team Member" },
      { name: "V L L Krishnaveni Emani", role: "Team Member" },
      { name: "Santosh Kumar Gupta", role: "Team Member" },
    ],
  },
  {
    id: "U2UCI052", domain: "Well Services", location: "Mumbai",
    title: "AI/ML Based Workover Rig Scheduling and Candidate Well Selection",
    lead: "Kaushal Agrawal", leadRole: "Team Lead",
    mentor: null, mentorRole: "",
    members: [
      { name: "Sohil Shah", role: "Model Training" },
      { name: "Alok Verma", role: "Programming" },
      { name: "Harini L", role: "Data Provisioning" },
    ],
  },
  {
    id: "U2UCI234", domain: "Finance", location: "Ahmedabad",
    title: "aiRR: AI Assisted IRR & Risk Framework for Optimal Well Drilling & Cost Efficiency",
    lead: "Satish Chandra Gupta", leadRole: "Team Lead",
    mentor: "Satish Kumar", mentorRole: "Team Mentor",
    members: [
      { name: "Bhargab Goswami", role: "Testing" },
      { name: "Hemasundara Rao Kambala", role: "Data & Implementation" },
      { name: "Raghvendra Sharma", role: "Model/Coding" },
    ],
  },
  {
    id: "U2UCI301", domain: "G&G", location: "KG Basin",
    title: "De-Risking Field Development via AI/ML Driven Petrophysical Rock Typing",
    lead: "Sabyasachi Bhowmick", leadRole: "Team Lead",
    mentor: "Sanjoy Das", mentorRole: "Team Mentor",
    members: [
      { name: "Shashi Kumar Suman", role: "ML Lead" },
      { name: "Shubham Gupta", role: "Domain Specialist" },
      { name: "Kitho Stephen", role: "Domain Specialist" },
      { name: "Neerudu Ragalbande", role: "ML Engineer" },
      { name: "Malini Chakraborty", role: "Domain Expert" },
    ],
  },
  {
    id: "U2UCI364", domain: "G&G", location: "SPIC Mumbai",
    title: "AI-Enabled Unified Block Intelligence System for Upstream Data Lineage",
    lead: "Rupjyoti Dutta", leadRole: "Technical Lead",
    mentor: "Ramkaran Singh", mentorRole: "Project Head",
    members: [
      { name: "Rupjyoti Dutta", role: "Technical Lead" },
      { name: "Jainendra Srivastava", role: "SME Block" },
      { name: "Bhairav Changkakoty", role: "Product Dev Lead" },
      { name: "Rakesh Kumar Yadav", role: "Team Lead" },
      { name: "Umang Nagpal", role: "Tech & Domain" },
      { name: "Kalaiselvi S.", role: "Documentation" },
      { name: "Brijesh Kr. Pandey", role: "Domain Expert" },
      { name: "Piyush Nayal", role: "Domain Expert" },
      { name: "Pawan Singh", role: "Domain Expert" },
      { name: "Hardeep P.", role: "Domain Expert" },
      { name: "Abhishek Bisui", role: "Domain Expert" },
      { name: "Rehan Ansari", role: "Domain Expert" },
      { name: "Dipankan S.", role: "Domain Expert" },
    ],
  },
  {
    id: "U2UCI021", domain: "Reservoir", location: "Mehsana",
    title: "Use of Artificial Intelligence in Well-Test Interpretation",
    lead: "Sabyasachi Saikia", leadRole: "Team Lead",
    mentor: "Abhineet Baruah", mentorRole: "Mentor",
    members: [
      { name: "Arnav", role: "Programming" },
      { name: "Anamika Gahlot", role: "Programming" },

      { name: "Adarsh Tripathi", role: "Data Acquisition" },
      { name: "Aamir Iqbal", role: "Data Acquisition" },
    ],
  },
  {
    id: "U2UCI307", domain: "Drilling", location: "Rajahmundry Asset | IDWE, Dehradun",
    title: "DRISHTI: Drilling with Real-time Intelligent Systems for Holistic & Timely Interventions",
    lead: "Shailesh Chandra Sinha", leadRole: "Team Mentor",
    mentor: "Vinod Kanobaji Zile", mentorRole: "Team Mentor",
    members: [
      { name: "Bala Saidulu Nallagondla", role: "Team Lead" },
      { name: "Rajjan Singh Thakur", role: "Full-Stack Architect" },
      { name: "Santosh Kumar Gupta", role: "Domain Expert" },
      { name: "Ramu Pedumajji", role: "Project Mgmt" },
      { name: "Pankaj kumar", role: "Data Acquisition" },
      { name: "Murugesan M K", role: "Domain Expert" },
      { name: "N Harish", role: "UX/UI Designer" },
      { name: "Krishna Reddy", role: "UX/UI Designer" },
    ],
  },
  {
    id: "U2UCI249", domain: "Artificial Lift", location: "NH Asset Mumbai",
    title: "ESP-360: Real-Time Failure & Residual Equipment Life Prediction Using AI",
    lead: "Choppala Satya Tej", leadRole: "Team Lead (ML Developer)",
    mentor: "Manoj Mishra", mentorRole: "Team Mentor",
    members: [
      { name: "Manoj Mehta", role: "ML Developer" },
      { name: "Saksham Gupta", role: "Dashboard & SAS Dev" },
      { name: "Ashish Saini", role: "Dashboard & SAS Dev" },
      { name: "Ashutosh Pathak", role: "Data Engineer" },
      { name: "Bhavishy Kumar Gupta", role: "Domain & Data SME" },
    ],
  },
  {
    id: "U2UCI447", domain: "Business Process", location: "A&AA Basin",
    title: "TATHYA AI: Validate. Enrich. Decide",
    lead: "Sudhir Sharma", leadRole: "Domain Lead",
    mentor: "Sarabjeet Singh Dhanjal", mentorRole: "Team Mentor",
    members: [
      { name: "Mandeep Singh", role: "Full Stack Dev" },
      { name: "Vinay Sahu", role: "Team Lead" },
    ],
  },
  {
    id: "U2UCI395", domain: "HSSE", location: "Mehsana",
    title: "AI-Based Real-Time PPE Compliance Monitoring System",
    lead: "Shrishti Awasthi", leadRole: "Team Lead",
    mentor: null, mentorRole: "",
    members: [],
  },
  {
    id: "U2UCI428", domain: "Process Plant", location: "Ahmedabad",
    title: "GGS Management App and Portal (GAMIJ)",
    lead: "Sonu Kumar Singh", leadRole: "Team Lead",
    mentor: null, mentorRole: "",
    members: [
      { name: "Sukumar Laha", role: "Process Logic & Data Ingestion" },
      { name: "Ravi Kumar Sharma", role: "Process Logic & Data Ingestion" },
      { name: "Alpesh Parmar", role: "Field Validation" },
    ],
  },
  {
    id: "U2UCI255", domain: "Process Plant", location: "Rajahmundry",
    title: "ML-Driven H₂S Elimination in Gas Pipelines and Strategic Reduction of Non-Eco Friendly Chemical Usage Across ONGC Installations",
    lead: "Rahman A M", leadRole: "Project Manager",
    mentor: "BSS Kumar", mentorRole: "Team Mentor",
    members: [
      { name: "Sushant Gupta", role: "Team Lead" },
      { name: "Hrushikesh Reddy", role: "Technical Lead" },
      { name: "Mudavath Priyatham Naik", role: "Programmer" },
      { name: "Jeetendra Bobanga", role: "Senior Programmer" },
      { name: "Koushik Mondal", role: "Quality Control" },
      { name: "Deepak Kumar Vishwakarma", role: "Maintenance Eng." },

    ],
  },
  {
    id: "U2UCI239", domain: "G&G", location: "Frontier Basin, Dehradun",
    title: "ML-Based Optimisation of Uphole Surveys in Onshore Seismic Data Acquisition",
    lead: "Sh Bronson Aimol", leadRole: "Team Lead",
    mentor: "Manav Kumar", mentorRole: "Mentor",
    members: [
      { name: "Saswata Bag", role: "Data Analysis" },
      { name: "Dharmendra Kumar", role: "SAS Analysis" },
    ],
  },
  {
    id: "U2UCI424", domain: "Artificial Lift", location: "Mehsana",
    title: "AI-Enabled Dynacard Fault Diagnosis for SRP Well",
    lead: "Sagun Devshali", leadRole: "Team Lead",
    mentor: null, mentorRole: "",
    members: [
      { name: "Deepak Gunwant", role: "Domain Expert" },
      { name: "Jitendra Dadhich", role: "Data Analytics Lead" },
      { name: "Rajjan Singh Thakur", role: "AI/ML Lead" },
    ],
  },
  {
    id: "U2UCI038", domain: "HSSE", location: "Corporate HSE",
    title: "A Centralised HSE Ranking System to Assess Safety Performance of Business Units",
    lead: "Arshad Hussain", leadRole: "Mentor",
    mentor: "Pawan Kumar Jalutharia", mentorRole: "Mentor",
    members: [
      { name: "Alka Yadav", role: "Team Lead" },
      { name: "Jayashree Prusty", role: "Program Dev. Leader" },
      { name: "Paul Mickey Toppo", role: "Program Developer" },
      { name: "Prem Prakash Hansda", role: "Program Developer" },
      { name: "Vivek Singh", role: "Onshore Input" },
    ],
  },
  {
    id: "U2UCI413", domain: "HSSE", location: "Assam Asset",
    title: "Utilization of Drilling Cuttings for Internal Road Laying and Civil Works",
    lead: "Nainesh B Shah", leadRole: "AI/Healthcare",
    mentor: "V. Sreedher", mentorRole: "Mentor",
    members: [
      { name: "Haritha Maddi", role: "Team Lead" },
      { name: "Roshan P Koshy", role: "IT Support" },

    ],
  },
  {
    id: "U2UCI126", domain: "Business Process", location: "GEOPIC",
    title: "Secure On-Premises Smart OCR for Enterprise Data Management",
    lead: "Santosh Kumar Sahu", leadRole: "Team Lead",
    mentor: "Nebula Bagchi", mentorRole: "Team Mentor",
    members: [
      { name: "Davinder Singh", role: "Team Mentor" },
      { name: "Prashant Kumar Dubey", role: "Team Mentor" },
      { name: "Venkatesh P", role: "Team Mentor" },
      { name: "Santosh Kumar Sahu", role: "Team Lead" },
      { name: "Suresh Konka", role: "Domain Expert" },
      { name: "Satya Narayan", role: "Domain Expert" },
      { name: "Nikhil Singh", role: "Domain Expert" },
      { name: "Neha Pandey", role: "Domain Expert" },
    ],
  },
  {
    id: "U2UCI232", domain: "Drilling", location: "Rajahmundry",
    title: "SmartChem: Smart Inventory Management and Forecasting",
    lead: "Vishal Mittal", leadRole: "Team Mentor",
    mentor: "Mathialagan P", mentorRole: "Mentor/Domain Expert",
    members: [
      { name: "Ramu Pedumajji", role: "Team Lead" },
      { name: "Rajjan Singh Thakur", role: "Full-Stack Architect" },
      { name: "Santosh Kumar Gupta", role: "Documentation" },


      { name: "Bala Saidulu Nallagondla", role: "Project Mgmt" },
      { name: "Pankaj kumar", role: "Data Acquisition" },

      { name: "Murugesan M K", role: "Data Acquisition" },
      { name: "N Harish", role: "UX/UI Designer" },
      { name: "Krishna Reddy", role: "UX/UI Designer" },
    ],
  },
  {
    id: "U2UCI376", domain: "Production", location: "Rajahmundry",
    title: "ML-Driven Well Flow Cycle Optimization",
    lead: "Vishal Mittal", leadRole: "Team Mentor",
    mentor: "Jayant Kumar", mentorRole: "Team Mentor",
    members: [
      { name: "Hrushikesh Reddy", role: "Team Lead" },
      { name: "Rahman A M", role: "Project Manager" },
      { name: "Mudavath Priyatham Naik", role: "Instrumentation" },

      { name: "Vaibhav Kumar Lakra", role: "Team Member" },
      { name: "Shubhendu Sharan Gupta", role: "Domain Expert" },
      { name: "Pankaj Kumar", role: "Domain Expert" },
      { name: "Veluri Raviteja", role: "Domain Expert" },
    ],
  },
  {
    id: "U2UCI290", domain: "Pipeline", location: "Mumbai",
    title: "AI-Based Virtual Inline Inspection (V-ILI) for Predictive Pipeline Integrity",
    lead: "Neeraj Kumar", leadRole: "Team Lead",
    mentor: null, mentorRole: "",
    members: [
      { name: "Rajiv Vasisth", role: "Team Member" },
      { name: "Peter Vaddi", role: "Team Member" },
      { name: "Pamini BN", role: "Team Member" },
    ],
  },
  {
    id: "U2UCI093", domain: "Well Services", location: "Delhi",
    title: "AI-Driven Economic Gatekeeping for Workover Jobs",
    lead: "Nirmal Kumar Mishra", leadRole: "Team Lead",
    mentor: "Devendra Kumar Aggarwal", mentorRole: "Team Mentor",
    members: [
      { name: "Sugata Guchhait", role: "Team Member" },
      { name: "Praveen Kumar Jha", role: "SAP Domain Expert" },
      { name: "Vishal Kumar", role: "Team Member" },
      { name: "Prateek Gupta", role: "Team Member" },
      { name: "Brijbhushan Ahuja", role: "Team Member" },
    ],
  },
  {
    id: "U2UCI414", domain: "G&G", location: "Western Offshore Basin",
    title: "Unlocking the Deep-water Frontier: AI-Driven Lithofacies Discrimination",
    lead: "Prosenjit Das", leadRole: "Team Lead",
    mentor: null, mentorRole: "",
    members: [

      { name: "G. Parthiban", role: "Team Member" },

      { name: "Sayandeep Roy", role: "Team Member" },
      { name: "Ayan Kumar Mondal", role: "Team Member" },
      { name: "Umang Nagpal", role: "Team Member" },

    ],
  },
  {
    id: "U2UCI444", domain: "IT", location: "Corporate Infocom Office",
    title: "AI-Enabled Digital Repository for MVT and Safety Competency Certificates",
    lead: "Manish Kumar", leadRole: "Team Lead",
    mentor: null, mentorRole: "",
    members: [
      { name: "Manish Kumar", role: "Team Lead" },
      { name: "Anshu Kumar", role: "Team Member" },
      { name: "Joseph Mattamana", role: "Team Member" },
      { name: "Nirmal Kumar Mishra", role: "Team Member" },
    ],
  },
  {
    id: "U2UCI445", domain: "Audit", location: "Corporate Infocom Office",
    title: "Agentic AI Solution for Automating and Augmenting the Nomination Audit Reports",
    lead: "Manish Kumar", leadRole: "Team Lead",
    mentor: "Sudesh Kakkar", mentorRole: "Team Mentor",
    members: [
      { name: "Sudesh Kakkar", role: "Team Mentor" },
      { name: "Manish Kumar", role: "Team Lead" },
      { name: "Anshu Kumar", role: "Team Member" },
      { name: "Joseph Mattamana", role: "Team Member" },
      { name: "Pawan Kumar", role: "Team Member" },
      { name: "Sreenath S. Das", role: "Team Member" },
    ],
  },
];

const pillars = [
  {
    num: "01",
    title: "Structured Development Sessions",
    desc: "Teams received regular, focused sessions with technical mentors and experts. Each session was designed not just to answer questions but to actively accelerate the build by identifying blockers, strengthening model design, and ensuring solutions were being built to a Demo Day standard.",
  },
  {
    num: "02",
    title: "SAS Platform Integration",
    desc: "Teams were supported in aligning their technical architecture with ONGC's enterprise AI platform, SAS, from the ground up. Solutions built on SAS are enterprise tools that ONGC can adopt, maintain, and scale without dependency on external vendors.",
  },
  {
    num: "03",
    title: "Business Case Sharpening",
    desc: "A technically sound solution that cannot articulate its business value will not get implemented.Every team refined and hardened their business case: quantifying ROI, defining implementation roadmaps, estimating timelines, and making the value proposition airtight for senior management.",
  },
  {
    num: "04",
    title: "Data Access & Integration",
    desc: "Data readiness is consistently the most underestimated bottleneck in AI implementation. Teams worked proactively to resolve data access, data quality, and system integration challenges before the final presentation.",
  },
];

// ─── Domain color map ──────────────────────────────────────────────────────
const domainColors = {
  "G&G": { bg: "rgba(139,92,246,0.12)", text: "#a78bfa", border: "rgba(139,92,246,0.25)" },
  "Drilling": { bg: "rgba(251,146,60,0.12)", text: "#fb923c", border: "rgba(251,146,60,0.25)" },
  "Process Plant": { bg: "rgba(16,185,129,0.12)", text: "#34d399", border: "rgba(16,185,129,0.25)" },
  "Well Services": { bg: "rgba(59,130,246,0.12)", text: "#60a5fa", border: "rgba(59,130,246,0.25)" },
  "Finance": { bg: "rgba(234,179,8,0.12)", text: "#facc15", border: "rgba(234,179,8,0.25)" },
  "Reservoir": { bg: "rgba(20,184,166,0.12)", text: "#2dd4bf", border: "rgba(20,184,166,0.25)" },
  "Artificial Lift": { bg: "rgba(244,63,94,0.12)", text: "#fb7185", border: "rgba(244,63,94,0.25)" },
  "Business Process": { bg: "rgba(99,102,241,0.12)", text: "#818cf8", border: "rgba(99,102,241,0.25)" },
  "HSSE": { bg: "rgba(239,68,68,0.12)", text: "#f87171", border: "rgba(239,68,68,0.25)" },
  "Production": { bg: "rgba(34,197,94,0.12)", text: "#4ade80", border: "rgba(34,197,94,0.25)" },
  "Pipeline": { bg: "rgba(14,165,233,0.12)", text: "#38bdf8", border: "rgba(14,165,233,0.25)" },
  "IT": { bg: "rgba(217,70,239,0.12)", text: "#d946ef", border: "rgba(217,70,239,0.25)" },
  "Audit": { bg: "rgba(132,204,22,0.12)", text: "#84cc16", border: "rgba(132,204,22,0.25)" },
};

function getDomainStyle(domain) {
  return domainColors[domain] || { bg: "rgba(255,255,255,0.06)", text: "#9ca3af", border: "rgba(255,255,255,0.12)" };
}

// ─── Member pill (compact) ────────────────────────────────────────────────
function MemberPill({ name, role }) {
  const isLead = role === "Team Lead";
  return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "10px",
      padding: "12px 6px",
      width: "100%",
      textAlign: "center",
    }}>
      <Avatar name={name} size={110} />
      <div style={{ width: "100%" }}>
        <div style={{ fontSize: "1.1rem", fontWeight: 700, color: "#e5e7eb", lineHeight: 1.25, whiteSpace: "normal", wordWrap: "break-word" }}>
          {name}
        </div>
        <div style={{ fontSize: "0.95rem", color: isLead ? "#10b981" : "#9ca3af", fontWeight: isLead ? 700 : 400, fontStyle: "italic", marginTop: "4px", lineHeight: 1.25, whiteSpace: "normal", wordWrap: "break-word" }}>
          {role}
        </div>
      </div>
    </div>
  );
}



// ─── Team Card ─────────────────────────────────────────────────────────────
function TeamCard({ c }) {
  const ds = getDomainStyle(c.domain);


  return (
    <div style={{
      background: "#0a0a0a",
      border: "1px solid #1a1a1a",
      borderRadius: "14px",
      overflow: "hidden",
      transition: "border-color 0.25s ease, box-shadow 0.25s ease",
    }}
      onMouseEnter={(e) => {
        e.currentTarget.style.borderColor = "rgba(16,185,129,0.3)";
        e.currentTarget.style.boxShadow = "0 6px 24px rgba(0,0,0,0.4)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.borderColor = "#161b22";
        e.currentTarget.style.boxShadow = "none";
      }}
    >
      {/* Accent bar */}
      <div style={{ height: "2px", background: "linear-gradient(90deg, #10b981 0%, transparent 70%)" }} />

      <div style={{ padding: "24px 22px", display: "flex", flexDirection: "column", gap: "16px" }}>

        {/* Top row: domain badge + id + location */}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: "8px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <span style={{
              fontSize: "0.72rem",
              fontWeight: 700,
              padding: "3px 9px",
              borderRadius: "5px",
              background: ds.bg,
              color: ds.text,
              border: `1px solid ${ds.border}`,
              letterSpacing: "0.03em",
            }}>
              {c.domain}
            </span>
            <span style={{ fontSize: "0.75rem", color: "#d1d5db" }}>·</span>
            <span style={{ fontSize: "0.75rem", color: "#d1d5db" }}>{c.location}</span>
          </div>
          <span style={{ fontSize: "0.75rem", fontWeight: 700, color: "#10b981", fontFamily: "monospace", letterSpacing: "0.04em" }}>
            {c.id}
          </span>
        </div>

        {/* Title */}
        <h3 style={{
          fontSize: "1rem",
          fontWeight: 700,
          background: "linear-gradient(135deg, #4ade80 0%, #34d399 50%, #f87171 100%)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
          lineHeight: 1.45,
          margin: 0,
        }}>
          {c.title}
        </h3>

        {/* Team Members row */}
        <div>
          <div style={{ fontSize: "0.68rem", fontWeight: 600, color: "#d1d5db", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: "8px" }}>
            Team Members
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6">
            {c.mentor && !c.members.some(m => m.name === c.mentor) && (
              <MemberPill name={c.mentor} role={c.mentorRole || "Mentor"} />
            )}
            {c.lead && !c.members.some(m => m.name === c.lead) && (
              <MemberPill name={c.lead} role={c.leadRole} />
            )}
            {c.members.map((m, i) => (
              <MemberPill key={i} name={m.name} role={m.role} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

// ─── Main component ────────────────────────────────────────────────────────
export default function Finalists() {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedDomain, setSelectedDomain] = useState("All");
  const [filteredCases, setFilteredCases] = useState(useCases);
  const [visible, setVisible] = useState(false);

  useLayoutEffect(() => { window.scrollTo(0, 0); }, []);
  useEffect(() => { const t = setTimeout(() => setVisible(true), 80); return () => clearTimeout(t); }, []);

  useEffect(() => {
    const term = searchTerm.toLowerCase();
    setFilteredCases(useCases.filter((c) => {
      const matchSearch =
        c.id.toLowerCase().includes(term) ||
        c.title.toLowerCase().includes(term) ||
        c.domain.toLowerCase().includes(term) ||
        c.location.toLowerCase().includes(term) ||
        c.lead.toLowerCase().includes(term) ||
        (c.mentor && c.mentor.toLowerCase().includes(term)) ||
        c.members.some((m) => m.name.toLowerCase().includes(term));
      const matchDomain = selectedDomain === "All" || c.domain === selectedDomain;
      return matchSearch && matchDomain;
    }));
  }, [searchTerm, selectedDomain]);

  const navigate = useNavigate();
  const domains = ["All", ...Array.from(new Set(useCases.map((c) => c.domain)))];

  const handleTabClick = (tab) => {
    if (tab === "article") navigate("/article");
    else if (tab === "shortlisted") navigate("/shortlisted");
    else if (tab === "finalists") navigate("/finalists");
    else navigate("/submission-insights");
  };

  return (
    <div style={{ fontFamily: "system-ui, -apple-system, sans-serif", background: "#000000", color: "#e8f5e9", minHeight: "100vh", overflowX: "hidden" }}>
      <style>{`
        * { box-sizing: border-box; }
        body { background-color: #000000; margin: 0; }
        ::selection { background: #00e5a033; }

        .fade-in { opacity: 0; transform: translateY(20px); transition: opacity 0.7s ease, transform 0.7s ease; }
        .fade-in.visible { opacity: 1; transform: none; }

        .tab-wrap { display: flex; flex-direction: column; gap: 6px; background: rgba(255,255,255,0.04); padding: 6px; border-radius: 14px; border: 1px solid rgba(255,255,255,0.08); width: 92%; }
        @media (min-width: 640px) { .tab-wrap { flex-direction: row; width: auto; border-radius: 999px; } }

        .tab-btn { flex: 1; white-space: nowrap; padding: 9px 20px; font-size: 0.82rem; font-weight: 600; border-radius: 999px; border: none; cursor: pointer; transition: all 0.18s ease; background: transparent; color: #9ca3af; }
        .tab-btn:hover { color: #fff; background: rgba(255,255,255,0.08); }
        .tab-btn.active { background: #10b981; color: #000; }

        .search-input { width: 100%; padding: 10px 16px; background: #0a0c0f; border: 1px solid #1a1f2e; border-radius: 8px; color: #e5e7eb; font-size: 0.9rem; outline: none; transition: border-color 0.2s ease, box-shadow 0.2s ease; }
        .search-input:focus { border-color: #10b981; box-shadow: 0 0 0 3px rgba(16,185,129,0.08); }
        .search-input::placeholder { color: #9ca3af; }

        .domain-pill { padding: 5px 13px; border-radius: 999px; font-size: 0.78rem; font-weight: 600; border: 1px solid rgba(255,255,255,0.08); background: rgba(255,255,255,0.02); color: #9ca3af; cursor: pointer; transition: all 0.15s ease; }
        .domain-pill:hover:not(.dp-active) { color: #d1d5db; background: rgba(255,255,255,0.06); }
        .domain-pill.dp-active { background: #10b981; color: #000; border-color: #10b981; }

        .pillar { background: #0a0a0a; border: 1px solid #161b22; border-radius: 12px; padding: 24px; display: flex; flex-direction: column; justify-content: space-between; transition: border-color 0.2s ease; }
        .pillar:hover { border-color: rgba(16,185,129,0.25); }

        .quote-block { position: relative; margin: 28px auto; max-width: 960px; padding: 10px 28px; border-radius: 10px; background: linear-gradient(90deg, rgba(16,185,129,0.08) 0%, rgba(5,5,5,0.3) 100%); }

        .stat-num { font-size: 2.6rem; font-weight: 900; display: block; }
        .stat-label { font-size: 0.78rem; font-weight: 700; text-transform: uppercase; letter-spacing: 1.5px; display: block; }

     
      `}</style>

      {/* ── HEADER ─────────────────────────────────────────────────────── */}
      <header style={{ padding: "10px 16px 24px", marginTop: "80px", display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", position: "relative", background: "#000000", borderBottom: "1px solid #1a1a1a" }}>

        {/* Tabs */}
        <div className="flex justify-center mb-6 w-full">
          <div className="flex flex-col sm:flex-row gap-2 bg-white/5 p-2 sm:p-1 rounded-2xl sm:rounded-full border border-white/10 w-[92%] sm:w-fit">
            <button
              onClick={() => handleTabClick("submission-insights")}
              className={`flex-1 whitespace-nowrap px-4 sm:px-6 py-2.5 sm:py-2 text-sm font-semibold rounded-full transition-all duration-200 ${"finalists" === "submission-insights"
                ? "bg-green-500 text-black shadow-md"
                : "text-gray-300 hover:text-white hover:bg-white/10"
                }`}
            >
              Submission Insights
            </button>

            <button
              onClick={() => handleTabClick("article")}
              className={`flex-1 whitespace-nowrap px-4 sm:px-6 py-2.5 sm:py-2 text-sm font-semibold rounded-full transition-all duration-200 ${"finalists" === "article"
                ? "bg-green-500 text-black shadow-md"
                : "text-gray-300 hover:text-white hover:bg-white/10"
                }`}
            >
              Evaluation Insights And Result
            </button>

            <button
              onClick={() => handleTabClick("shortlisted")}
              className={`flex-1 whitespace-nowrap px-4 sm:px-6 py-2.5 sm:py-2 text-sm font-semibold rounded-full transition-all duration-200 ${"finalists" === "shortlisted"
                ? "bg-green-500 text-black shadow-md"
                : "text-gray-300 hover:text-white hover:bg-white/10"
                }`}
            >
              Shortlisted Use Cases
            </button>

            <button
              onClick={() => handleTabClick("finalists")}
              className={`flex-1 whitespace-nowrap px-4 sm:px-6 py-2.5 sm:py-2 text-sm font-semibold rounded-full transition-all duration-200 ${"finalists" === "finalists"
                ? "bg-green-500 text-black shadow-md"
                : "text-gray-300 hover:text-white hover:bg-white/10"
                }`}
            >
              Meet the Finalists
            </button>
          </div>
        </div>

        <h1 className="text-2xl sm:text-3xl md:text-4xl font-extrabold mb-4 sm:mb-6 bg-gradient-to-r from-green-400 via-emerald-400 to-red-400 bg-clip-text text-transparent tracking-tight leading-tight" style={{ maxWidth: "900px" }}>
          From Prototypes to the Demo Day
        </h1>
        <p style={{ fontSize: "clamp(0.9rem, 2vw, 1.05rem)", color: "#d1d5db", maxWidth: "800px", lineHeight: 1.65, margin: 0, padding: "0 16px", fontWeight: 400 }}>
          How 25 teams took their proof of concept, built a full working solution, and piloted it at a trial location
          within ONGC, proving AI-led transformation at ONGC is no longer a future ambition. It is already
          underway.
        </p>
      </header>

      {/* ── MAIN ───────────────────────────────────────────────────────── */}
      <main className={`fade-in ${visible ? "visible" : ""}`} style={{ maxWidth: "1050px", margin: "0 auto", padding: "32px 16px 80px", background: "#000000" }}>

        {/* INTRO */}
        <section style={{ paddingBottom: "15px", marginBottom: "0" }}>
          <p style={{ fontSize: "1.05rem", lineHeight: 1.7, color: "#d1d5db", marginBottom: "18px" }}>
            At the end of the POC stage, 35 teams had done something remarkable. They had taken an idea that
            was originally submitted in a form, refined it in a conversation, shortlisted it through rigorous evaluation
            and turned it into a working proof of concept. Built on real ONGC data. Demonstrated before the multi-
            disciplinary leadership team. Validated as technically sound and operationally relevant.          </p>
          <p style={{ fontSize: "1.05rem", lineHeight: 1.7, color: "#d1d5db", marginBottom: "18px" }}>
            But Udbhav 2.0 was not designed to stop at a prototype.
          </p>
          <p style={{ fontSize: "1.05rem", lineHeight: 1.7, color: "#d1d5db", marginBottom: "18px" }}>
            What followed was the most demanding phase of the entire programme: the build phase. Teams were
            asked to take everything they had built and evolve it into a full, enterprise-ready AI solution that was
            robust enough to withstand the scrutiny of ONGC's top management, and ready enough to be
            considered for implementation across the organisation.          </p>

          <div style={{ marginTop: "10px", textAlign: "center" }}>
            <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                background: "rgba(16,185,129,0.07)",
                border: "1px solid rgba(16,185,129,0.2)",
                borderRadius: "999px",
                padding: "2px 16px",
              }}
            >
              <span
                style={{
                  width: "7px",
                  height: "7px",
                  borderRadius: "50%",
                  background: "#10b981",
                  flexShrink: 0,
                }}
              />
              <span
                style={{
                  fontSize: "0.88rem",
                  color: "#4ade80",
                  fontWeight: 600,
                }}
              >
                25 teams completed that journey. Today, they stand on the Demo Day stage.
              </span>
            </div>
          </div>
        </section>

        {/* FINAL BUILD */}
        {/* FINAL BUILD */}
        <section style={{ padding: "24px 0 32px" }}>
          <div>
            <h2
              style={{
                fontSize: "1.6rem",
                fontWeight: 800,
                background:
                  "linear-gradient(135deg, #4ade80 0%, #34d399 50%, #f87171 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                textAlign: "center",
                marginBottom: "14px",
              }}
            >
              The Final Build: Months of Intensive Development
            </h2>

            <p style={{ fontSize: "1.05rem", lineHeight: 1.7, color: "#d1d5db", marginBottom: "18px" }}>
              The transition from POC to final solution is not a refinement exercise. It is a build phase, one that
              requires teams to go significantly deeper on every dimension: the technical architecture, the data
              pipeline, the business case, and the implementation roadmap.
            </p>

            <p style={{ fontSize: "1.05rem", lineHeight: 1.7, color: "#d1d5db", marginBottom: "18px" }}>
              To support this, four structured pillars of assistance were made available to every advancing team
              throughout the development period.
            </p>

            {/* PILLARS */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-[18px] mb-[28px]">
              {pillars.map((p, i) => (
                <div
                  key={i}
                  style={{
                    background: "rgba(255,255,255,0.02)",
                    border: "1px solid rgba(255,255,255,0.08)",
                    borderRadius: "18px",
                    padding: "18px",
                    backdropFilter: "blur(10px)",
                    transition: "all 0.25s ease",
                  }}
                >
                  {/* Number + Title */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      marginBottom: "12px",
                    }}
                  >
                    <span
                      style={{
                        fontSize: "0.95rem",
                        fontWeight: 900,
                        color: "#10b981",
                        fontFamily: "monospace",
                        letterSpacing: "-0.02em",
                        flexShrink: 0,
                      }}
                    >
                      {p.num}
                    </span>

                    <h4
                      style={{
                        margin: 0,
                        fontSize: "0.95rem",
                        fontWeight: 700,
                        color: "#f3f4f6",
                        lineHeight: 1.35,
                      }}
                    >
                      {p.title}
                    </h4>
                  </div>

                  {/* Description */}
                  <p
                    style={{
                      margin: 0,
                      color: "#d1d5db",
                      fontSize: "0.84rem",
                      lineHeight: 1.7,
                    }}
                  >
                    {p.desc}
                  </p>
                </div>
              ))}
            </div>

            {/* CONCLUSION */}
            <div>
              <p style={{ fontSize: "1.05rem", lineHeight: 1.7, color: "#d1d5db", marginBottom: "18px" }}>
                The quality of what emerged from this phase was, by any measure, a significant step beyond the POC.
                Teams arrived at the Final Presentation with working solutions, tested on real ONGC data, supported
                by documented business cases, and ready for the most demanding audience of their Udbhav journey.
              </p>

              {/* <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "20px",
                }}
              >
                <div
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "8px",
                    background: "rgba(16,185,129,0.08)",
                    border: "1px solid rgba(16,185,129,0.2)",
                    borderRadius: "999px",
                    padding: "8px 18px",
                    maxWidth: "900px",
                  }}
                >
                  <span
                    style={{
                      width: "7px",
                      height: "7px",
                      borderRadius: "50%",
                      background: "#10b981",
                      flexShrink: 0,
                    }}
                  />

                  <span
                    style={{
                      fontSize: "0.88rem",
                      color: "#4ade80",
                      fontWeight: 600,
                      textAlign: "center",
                      lineHeight: 1.5,
                    }}
                  >
                    Teams reached Demo Day with working solutions, validated on real
                    ONGC datasets, supported by documented business cases, and prepared
                    for the most demanding evaluation of their Udbhav journey.
                  </span>
                </div>
              </div> */}
            </div>
          </div>
        </section>
        {/* FINAL PRESENTATION */}
        <section style={{ padding: "10px 0 20px" }}>
          <h2 style={{ fontSize: "1.6rem", fontWeight: 800, background: "linear-gradient(135deg, #f87171 0%, #34d399 50%, #f87171 100%)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", marginBottom: "12px", textAlign: "center" }}>
            The Final Presentation: Scrutiny at the Highest Level
          </h2>
          <p style={{ fontSize: "1.05rem", lineHeight: 1.7, color: "#d1d5db", marginBottom: "18px" }}>
            Before reaching Demo Day, each team had to clear one final threshold: the Final Presentation before a
            multi-disciplinary leadership committee. This was not a rehearsal. It was a full evaluation that was
            structured, probing, and decisive.          </p>
          <p style={{ fontSize: "1.05rem", lineHeight: 1.7, color: "#d1d5db", marginBottom: "18px" }}>
            Each team presented their complete solution across four dimensions: the problem they were solving
            and why it matters to ONGC; the AI approach they had taken and how it works; the outcomes
            demonstrated during their POC and full build; and the business case, including projected ROI,
            implementation pathway, and scalability across the organisation.</p>
          <p style={{ fontSize: "1.05rem", lineHeight: 1.7, color: "#d1d5db", marginBottom: "18px" }}>
            Leadership engaged with depth. Questions were probing. Assumptions were challenged. In a number
            of cases, connections were identified between use cases, pointing toward potential synergies in
            implementation that neither team had initially seen. What unfolded across these sessions was not just
            an evaluation; it was a preview of what ONGC's AI-powered future could look like.
          </p>
          <div className="quote-block" style={{ background: "linear-gradient(299deg, rgb(232 32 32 / 6%) 0%, rgb(232 60 60 / 50%) 100%)", borderRadius: "12px", padding: "20px", marginBottom: "14px" }}>
            <p style={{ fontSize: "1.05rem", fontStyle: "italic", color: "#e8f5e9", margin: "0 0 8px", lineHeight: 1.6 }}>
              “These are not teams presenting a project. These are ONGCians who have built the future
              of their function and are now showing us how to deploy it.”
            </p>
            <p style={{ fontSize: "0.85rem", color: "#86efac", fontWeight: 600, margin: 0 }}>
              — Shri Manoj Kujur, GGM (E&amp;T) and Head Communication
            </p>
          </div>
          <p style={{ fontSize: "1.05rem", lineHeight: 1.7, color: "#d1d5db" }}>
            From the 35 teams that completed the POC stage, 25 completed their final presentation to advance to
            Demo Day. Each of these 25 Use Cases was selected based on the maturity of the solution, the
            strength of the business case, and the demonstrable readiness for enterprise-wide implementation.    </p>
        </section>

        {/* FINALISTS GRID */}
        <section style={{ padding: "10px 0 20px" }}>
          <div style={{ textAlign: "center", marginBottom: "24px" }}>
            <h2 style={{ fontSize: "1.6rem", fontWeight: 800, background: "linear-gradient(135deg, #f87171 0%, #34d399 50%, #f87171 100%)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", margin: "0 0 8px" }}>
              The 25 Finalists of Udbhav 2.0
            </h2>
            <p style={{ fontSize: "1.05rem", color: "#d1d5db", margin: "0 auto" }}>
              The 25 teams advancing to Demo Day represent the best of what ONGC's workforce has built across
              the entire Udbhav 2.0 journey. Their solutions span 13 domains and address some of the organisation's
              most persistent operational, safety, financial, and strategic challenges.
            </p>
          </div>

          {/* Search & filter */}
          <div style={{ background: "#0a0a0a", border: "1px solid #1a1a1a", borderRadius: "12px", padding: "20px", marginBottom: "20px" }}>
            <div style={{ marginBottom: "16px" }}>
              <label style={{ fontSize: "0.78rem", color: "#d1d5db", fontWeight: 600, display: "block", marginBottom: "8px", textTransform: "uppercase", letterSpacing: "0.06em" }}>Search Finalists</label>
              <input
                type="text"
                placeholder="Search by Team ID, title, lead, mentor, or member name…"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="search-input"
              />
            </div>
            <div>
              <label style={{ fontSize: "0.78rem", color: "#d1d5db", fontWeight: 600, display: "block", marginBottom: "10px", textTransform: "uppercase", letterSpacing: "0.06em" }}>Filter by Domain</label>
              <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                {domains.map((d, i) => (
                  <button key={i} className={`domain-pill${selectedDomain === d ? " dp-active" : ""}`} onClick={() => setSelectedDomain(d)}>
                    {d}
                  </button>
                ))}
              </div>
            </div>
          </div>

          {/* Count bar */}
          <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "16px" }}>
            <div style={{ height: "1px", flex: 1, background: "linear-gradient(90deg, transparent, #161b22)" }} />
            <span style={{ fontSize: "0.75rem", color: "#d1d5db", fontWeight: 600, whiteSpace: "nowrap" }}>
              Showing <span style={{ color: "#d1d5db" }}>{filteredCases.length}</span> of {useCases.length}
            </span>
            <div style={{ height: "1px", flex: 1, background: "linear-gradient(270deg, transparent, #161b22)" }} />
          </div>


          <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            {filteredCases.map((c) => <TeamCard key={c.id} c={c} />)}
          </div>
          <p style={{
            fontSize: "1.05rem", lineHeight: 1.75, color: "#d1d5db", marginBottom: "14px", "margin-top": "19px"
          }}>
            Taken together, these 25 solutions carry an estimated five-year business value that runs into thousands of crores in cost avoidance, revenue enhancement, safety improvement, and operational efficiency. But the number is secondary to what these solutions represent: ONGC's own talent, solving ONGC's own problems, with tools built and owned by ONGC.       </p>          {/* Cards */}
          {filteredCases.length === 0 && (
            <div style={{ textAlign: "center", padding: "40px", border: "1px dashed #1a1f2e", borderRadius: "12px", color: "#d1d5db", fontSize: "0.9rem" }}>
              No finalists match your search or filter.
            </div>
          )}
        </section>

        {/* WHAT THESE SOLUTIONS DO */}
        <section style={{ padding: "10px 0 20px" }}>
          <h2 style={{ fontSize: "1.6rem", fontWeight: 800, background: "linear-gradient(135deg, #f87171 0%, #4ade80 50%, #f87171 100%)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", marginBottom: "12px", textAlign: "center" }}>
            What These Solutions Do
          </h2>
          <p style={{ fontSize: "1.05rem", lineHeight: 1.75, color: "#d1d5db", marginBottom: "14px" }}>
            The 25 finalists address challenges across the length and breadth of ONGC's operations. Some solutions operate at the level of individual wells. Others operate at the asset or organisational level. A particularly striking thread running through several of these solutions is the convergence of AI and sustainability.         </p>
          <div style={{ background: "#0a0a0a", border: "1px solid #1a1a1a", borderLeft: "3px solid #ec5555ff", borderRadius: "10px", padding: "18px 20px", marginBottom: "14px" }}>
            <p style={{ fontSize: "1.05rem", lineHeight: 1.7, color: "#d1d5db", margin: 0 }}>
              <strong style={{ color: "#d1d5db" }}>Key ESG Pilots:</strong> One team from Assam Asset built a solution to reuse drill cuttings as civil construction material, converting an operational waste stream into a resource and delivering an estimated saving of over {" "}
              <span style={{ color: "#f26d64ff", fontWeight: 600 }}>Rs. 145 crore annually</span>.  Another team from Rajahmundry developed an ML-based system to optimize H2S scavenger dosing, reducing chemical consumption by{" "}
              <span style={{ color: "#4ade80", fontWeight: 600 }}>40–45%</span> while improving pipeline safety. AI, in these solutions, is not just an efficiency tool. It is an ESG tool.
            </p>
          </div>
          <p style={{ fontSize: "1.05rem", lineHeight: 1.75, color: "#d1d5db" }}>
            Across all 25 solutions, what is consistent is this: they were built by the people who understand the problem best. Not a consultant's interpretation of the problem. Not a vendor's generic framework applied to ONGC's context. The real problem, as experienced by the person who faces it every day, is solved with precision.
          </p>
        </section>

        {/* DEMO DAY */}
        <section style={{ padding: "10px 0 20px" }}>
          <h2 style={{ fontSize: "1.6rem", fontWeight: 800, background: "linear-gradient(135deg, #f87171 0%, #34d399 50%, #f87171 100%)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", marginBottom: "12px", textAlign: "center" }}>
            Demo Day: A Decision Point, Not Just a Ceremony
          </h2>
          <p style={{ fontSize: "1.05rem", lineHeight: 1.75, color: "#d1d5db", marginBottom: "14px" }}>
            Demo Day is the culmination of a journey that began with a submission form in January 2026. But it is not just a celebration. It is a decision point.            </p>
          <p style={{ fontSize: "1.05rem", lineHeight: 1.75, color: "#d1d5db", marginBottom: "14px" }}>
            The 25 finalists will present their solutions to ONGC's senior management. The evaluation will focus on three questions: Is this solution ready to be deployed? Can it scale beyond the team and location that built it? And what does it take to make that happen?          </p>
          <div style={{ background: "linear-gradient(299deg, rgb(232 32 32 / 6%) 0%, rgb(232 60 60 / 50%) 100%)", borderRadius: "12px", padding: "20px", marginBottom: "14px" }}>
            <p style={{ fontSize: "1.05rem", lineHeight: 1.7, color: "#d1d5db", fontWeight: 500, margin: 0, textAlign: "center" }}>
              The best solutions will not stop at the podium. They will move from Demo Day into enterprise-wide implementation, becoming a permanent part of how ONGC operates. Following the tradition established in Udbhav 1.0, the top teams will be recognised with ONGC's prestigious awards.
            </p>
          </div>
          <p style={{ fontSize: "1.05rem", lineHeight: 1.75, color: "#d1d5db", marginBottom: "14px" }}>
            Every team that has reached this stage has already demonstrated something that cannot be undone. They have built a working AI solution. They have shown that ONGC's digital transformation does not require an external agency or an imported blueprint. It requires only what these teams have already provided: the right platform, the right support, and the people who already understand the problems best.
          </p>
        </section>

        {/* STATS BANNER */}
        <section style={{ paddingTop: "10px" }}>
          <div style={{ background: "linear-gradient(135deg, #07090c 0%, #030507 100%)", border: "1px solid #1a1a1a", borderRadius: "16px", padding: "10px 20px", textAlign: "center" }}>
            <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: "0", marginBottom: "28px" }}>
              {[
                { val: "542", label: "Ideas", accent: false },
                { val: "372", label: "Teams", accent: false },
                { val: "35", label: "Prototypes", accent: false },
                { val: "25", label: "Final Solutions", accent: true },
              ].map(({ val, label, accent }, i, arr) => (
                <div key={i} style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ padding: "0 24px", textAlign: "center" }}>
                    <span className="stat-num" style={{ color: accent ? "#10b981" : "#fff" }}>{val}</span>
                    <span className="stat-label" style={{ color: accent ? "#10b981" : "#9ca3af" }}>{label}</span>
                  </div>
                  {i < arr.length - 1 && (
                    <div style={{ width: "1px", height: "48px", background: "#161b22", flexShrink: 0 }} />
                  )}
                </div>
              ))}
            </div>
            <p style={{ fontSize: "1.05rem", fontStyle: "italic", color: "#4ade80", fontWeight: 600, margin: 0, lineHeight: 1.5 }}>
              The Udbhav 2.0 journey ends with the Demo Day and ONGC's AI transformation begins.
            </p>
          </div>
        </section>

      </main>
    </div >
  );
}